export const ALL_CATEGORIES_DEPTH_VALUE = -1;
